/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbServiceTutelleDto
 */
export interface FcbServiceTutelleDto {
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleDto
     */
    idserviceTutelle?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    codePays?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleDto
     */
    iddirectionTerritoriale?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleDto
     */
    idcop?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    commune?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    ouverture?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbServiceTutelleDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbServiceTutelleDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleDto
     */
    idserviceTutelleGuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbServiceTutelleDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbServiceTutelleDto interface.
 */
export function instanceOfFcbServiceTutelleDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbServiceTutelleDtoFromJSON(json: any): FcbServiceTutelleDto {
    return FcbServiceTutelleDtoFromJSONTyped(json, false);
}

export function FcbServiceTutelleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbServiceTutelleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idserviceTutelle': !exists(json, 'idserviceTutelle') ? undefined : json['idserviceTutelle'],
        'codePays': !exists(json, 'codePays') ? undefined : json['codePays'],
        'iddirectionTerritoriale': !exists(json, 'iddirectionTerritoriale') ? undefined : json['iddirectionTerritoriale'],
        'idcop': !exists(json, 'idcop') ? undefined : json['idcop'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'commune': !exists(json, 'commune') ? undefined : json['commune'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'ouverture': !exists(json, 'ouverture') ? undefined : json['ouverture'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'idserviceTutelleGuid': !exists(json, 'idserviceTutelleGuid') ? undefined : json['idserviceTutelleGuid'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbServiceTutelleDtoToJSON(value?: FcbServiceTutelleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idserviceTutelle': value.idserviceTutelle,
        'codePays': value.codePays,
        'iddirectionTerritoriale': value.iddirectionTerritoriale,
        'idcop': value.idcop,
        'code': value.code,
        'nom': value.nom,
        'adresse': value.adresse,
        'codePostal': value.codePostal,
        'localite': value.localite,
        'commune': value.commune,
        'telephone': value.telephone,
        'fax': value.fax,
        'ouverture': value.ouverture,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'creationUser': value.creationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'idserviceTutelleGuid': value.idserviceTutelleGuid,
        'actif': value.actif,
    };
}

